import Sidebar from "../../../../components/ui/sidebar";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../components/ui/card";
import { PawPrint as PawIcon } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface PetForm {
  name: string;
  type: string;
  breed: string;
  imageUrl: string;
}

export default function CreatePetPage() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<PetForm>({
    name: "",
    type: "",
    breed: "",
    imageUrl: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulación de guardado (puedes integrar con una API aquí)
    console.log("Mascota guardada:", formData);
    navigate("/pets"); // Redirige a la lista de mascotas
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-gray-900">
      <Sidebar />
      <main className="flex-1 p-6 md:ml-64 transition-all">
        <h2 className="text-3xl font-bold mb-6">Agregar mascota</h2>
        <Card className="shadow-lg border-l-4 border-purple-500">
          <CardHeader>
            <CardTitle>Agregar nueva mascota</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Nombre</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="mt-1 block w-full p-2 border rounded"
                  placeholder="Digita el nombre"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Tipo</label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="mt-1 block w-full p-2 border rounded"
                  required
                >
                  <option value="">Selecciona un tipo</option>
                  <option value="Canino">Canino</option>
                  <option value="Felino">Felino</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Raza</label>
                <input
                  type="text"
                  name="breed"
                  value={formData.breed}
                  onChange={handleChange}
                  className="mt-1 block w-full p-2 border rounded"
                  placeholder="Digita la raza"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full bg-green-600 text-white py-2 rounded-full hover:bg-green-700 transition"
              >
                Guardar
              </button>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}